<template>
	<el-row>
		<el-col>
			<el-menu :router="routerMode" class="el-menu-vertical-demo full-height" background-color="#fff"
				text-color="#000" :default-active="activeIndex" :collapse-transition="true" :unique-opened="true"
				ref="menu">
				<slot name="trademark" />
				<slot name="router" />
			</el-menu>
		</el-col>
	</el-row>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {
			routerMode: true
		};
	},
	computed: {
		...mapState(["activeIndex"])
	},
	mounted() {
		this.$refs.menu.open(this.$route.meta[0].activeRoute);
	},
	watch: {
		$route(val) {
			if (val) {
				this.$refs.menu.open(val.meta[0].activeRoute);
			}
		}
	}
};
</script>

<style scoped>
.full-height {
	height: 100vh;
}

.el-menu {
	overflow: hidden;
	overflow-y: auto;
}
</style>
